import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ChangeDetectorRef,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule, FormGroup } from '@angular/forms';
import { environment } from '../../../../environments/environment';
import { FormsServiceService } from '../../../api/services/forms-service.service';

@Component({
  selector: 'app-checkbox-type-two',
  imports: [CommonModule, ReactiveFormsModule, FormsModule],
  templateUrl: './checkbox-type-two.component.html',
  styleUrl: './checkbox-type-two.component.css',
})
export class CheckboxTypeTwoComponent {
  @Input() formGroup!: FormGroup;
  @Input() fields: any;
  @Input() disableFields: any;
  @Output() handleTaskMappingDependency = new EventEmitter<{
    fieldName: string;
    tags: any[];
    selectedQuestion: any;
  }>();
  selectedOptions: any[] = [];
  fieldsData: any;
  endpoint = environment.api_endpoint;
  constructor(
    private formService: FormsServiceService,
    private cdr: ChangeDetectorRef,
  ) {}
  ngOnInit() {
    this.getData();
    if (this.fields && this.fields?.value?.length) {
      this.selectedOptions = [...this.fields.value];
      this.control?.setValue(this.selectedOptions);
    }
  }

  get control() {
    return this.formGroup.get(this.fields.fieldName);
  }

  /** Function to get the data by api or static */
  getData() {
    if (this.fields.options.isStatic === true) {
      this.fieldsData = this.fields.options.staticOptions;
    } else {
      const formId = this.fields.options.source.formID;
      const api_endpoint = this.endpoint;
      const method = this.fields.options.source.method;
      let url = this.fields.options.source.apiUrl;
      const replacements = {
        formID: formId,
        api_endpoint: api_endpoint,
      };
      url = this.formService.replaceTemplateTokens(url, replacements);
      const headers = {
        'Content-Type': 'application/json',
      };
      this.formService.loadData(method, url, headers).subscribe({
        next: (res: any) => {
          this.fieldsData = res.data.records;
          this.restoreTagsFromSelectedOptions();
          this.cdr.detectChanges();
        },
        error: (err: any) => {
          console.error('Error fetching form data:', err);
          this.cdr.detectChanges();
        },
      });
    }
  }

  restoreTagsFromSelectedOptions() {
    const control = this.formGroup.get(this.fields.fieldName);
    const tagsControl = this.formGroup.get(this.fields.fieldName + 'Tags');

    if (!control || !tagsControl) return;

    const fieldName = this.resolveFieldName(this.fields);

    const rawValues = control.value || this.fields?.value || [];

    // Normalize → ALWAYS convert to tags (names)
    const selectedTags = (this.fieldsData || [])
      .filter(
        (opt: any) =>
          rawValues.includes(opt._id) || rawValues.includes(opt.name),
      )
      .map((opt: any) => opt.name);

    this.selectedOptions = [...rawValues];

    tagsControl.setValue(selectedTags);

    // ✅ Now this will NEVER send _id
    this.handleTaskMappingDependency.emit({
      fieldName,
      tags: selectedTags,
      selectedQuestion: '',
    });
  }
  /** Function to get the selectedOptions and apply styles to them */
  toggleSelection(option: any) {
    const control = this.formGroup.get(this.fields.fieldName);
    const tagsControl = this.formGroup.get(this.fields.fieldName + 'Tags');

    if (!control || !tagsControl) return;

    const optionId = option._id;

    this.selectedOptions = [...(control.value || this.selectedOptions || [])];

    if (this.selectedOptions.includes(optionId)) {
      // Remove ID and name
      this.selectedOptions = this.selectedOptions.filter(
        (o: string) => o !== optionId,
      );
    } else {
      // Add ID and name
      this.selectedOptions = [...this.selectedOptions, optionId];
    }

    const selectedTags = (this.fieldsData || [])
      .filter((opt: any) => this.selectedOptions.includes(opt._id))
      .map((opt: any) => opt.name);

    const fieldName = this.resolveFieldName(this.fields);
    tagsControl.setValue(selectedTags, { emitEvent: false });
    control.setValue(this.selectedOptions, { emitEvent: false });
    control.markAsTouched();
    control.updateValueAndValidity({ emitEvent: false });
    this.handleTaskMappingDependency.emit({
      fieldName,
      tags: selectedTags,
      selectedQuestion: '',
    });
  }

  /** Function to get the selectedOptions and apply styles to them */
  isSelected(option: any): boolean {
    const control = this.formGroup.get(this.fields.fieldName);
    const selectedOptions = control?.value || [];
    return selectedOptions.includes(option._id);
  }

  private resolveFieldName(field: any): string {
    if (!field) return '';

    // ✅ Case 1: direct string
    if (typeof field.fieldName === 'string') {
      return field.fieldName;
    }

    // ✅ Case 2: object { label, value }
    if (field.fieldName?.label) {
      return field.fieldName.label;
    }

    // ✅ Case 3: value[] format
    if (Array.isArray(field)) {
      return this.getValueByKey(field, 'fieldName') || '';
    }

    // ✅ Case 4: field.value is array (very common in your setup)
    if (Array.isArray(field.value)) {
      return this.getValueByKey(field.value, 'fieldName') || '';
    }

    return '';
  }

  private getValueByKey(arr: any[], key: string): any {
    return (arr || []).find((item: any) => item.Key === key)?.Value;
  }
}
